module.exports = __webpack_public_path__ + "img/kuaidiniao.65bf14fe.png";